module.exports = __webpack_public_path__ + "static/media/manutenzioni_miniatura.f348b52e.jpg";